import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M16.058 3.058a.625.625 0 0 1 .884 0l4 4a.625.625 0 0 1 0 .884l-4 4a.625.625 0 1 1-.884-.884l2.933-2.933H3.5a.625.625 0 1 1 0-1.25h15.491l-2.933-2.933a.625.625 0 0 1 0-.884Zm-8.116 9a.625.625 0 0 1 0 .884l-2.933 2.933H20.5a.625.625 0 1 1 0 1.25H5.009l2.933 2.933a.625.625 0 1 1-.884.884l-4-4a.625.625 0 0 1 0-.884l4-4a.625.625 0 0 1 .884 0Z"
    />
  </svg>
`;
